import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';

export const ERROR_NOTIFICATION = 'error-notification';

const ErrorNotification = ({
  errorMessage,
  errorToCopy,
  showCopyButton = false,
}) => {
  const [messageIsCopied, setMessageIsCopied] = useState(false);

  const copyToClipBoard = async (copyText) => {
    await navigator.clipboard.writeText(copyText);
    setMessageIsCopied(true);
  };

  return (
    <>
      <p>
        <FormattedMessage id={errorMessage} />
      </p>
      {showCopyButton && (
        <div className={`${ERROR_NOTIFICATION}__message-container`}>
          <p className={`${ERROR_NOTIFICATION}__error-message-text`}>
            <FormattedMessage id={errorToCopy} />
          </p>
          <button
            className={classnames(
              `${ERROR_NOTIFICATION}__copy-message-button`,
              {
                [`${ERROR_NOTIFICATION}__copy-message-button--copied`]:
                  messageIsCopied,
                [`${ERROR_NOTIFICATION}__copy-message-button--copy-message`]:
                  !messageIsCopied,
              },
            )}
            // the copied message needs to be encrypted
            onClick={() => copyToClipBoard(window.btoa(errorToCopy))}
            disabled={messageIsCopied}
          >
            {messageIsCopied ? (
              <FormattedMessage id={'api-error.notification.button.copied'} />
            ) : (
              <FormattedMessage
                id={'api-error.notification.button.copy-details'}
              />
            )}
          </button>
        </div>
      )}
      <button
        className={`${ERROR_NOTIFICATION}__submit-ticket-button`}
        onClick={() => {
          // open support website
          window.open(ROUTE_CONSTANTS.SERVICE_NOW);
        }}
      >
        <FormattedMessage id={'api-error.notification.button.submit-ticket'} />
      </button>
    </>
  );
};

export default ErrorNotification;
